import * as React from "react";
import { memo } from "react";

// can't use webapp icons package due to outdated react version
interface IProps {
  className?: string;
  color: string;
}

const RemeasureIcon: React.FC<IProps> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="14" height="14" rx="7" fill={color} />
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        stroke="white"
        strokeOpacity="0.6"
      />
      <path
        d="M4.49982 8.00016H5.54399C5.80649 8.00016 5.93482 8.31516 5.74816 8.496L4.12066 10.1235C4.00399 10.2402 3.82316 10.2402 3.70649 10.1235L2.07899 8.496C1.89816 8.31516 2.02649 8.00016 2.28899 8.00016H3.33316C3.33316 5.42183 5.42149 3.3335 7.99982 3.3335C8.60649 3.3335 9.18982 3.45016 9.72066 3.666C10.1115 3.8235 10.2165 4.32516 9.91899 4.62266C9.76149 4.78016 9.52232 4.84433 9.31232 4.75683C8.90982 4.58766 8.46066 4.50016 7.99982 4.50016C6.06899 4.50016 4.49982 6.06933 4.49982 8.00016ZM6.08066 11.3777C6.23816 11.2202 6.48316 11.156 6.68732 11.2435C7.09566 11.4068 7.53899 11.5002 7.99982 11.5002C9.93066 11.5002 11.4998 9.931 11.4998 8.00016H10.4557C10.1932 8.00016 10.0648 7.68516 10.2515 7.50433L11.879 5.87683C11.9957 5.76016 12.1765 5.76016 12.2932 5.87683L13.9207 7.50433C14.1015 7.68516 13.9732 8.00016 13.7165 8.00016H12.6665C12.6665 10.5785 10.5782 12.6668 7.99982 12.6668C7.39316 12.6668 6.80982 12.5502 6.27899 12.3343C5.88816 12.1768 5.78316 11.6752 6.08066 11.3777Z"
        fill="white"
      />
    </svg>
  );
};

export default memo(RemeasureIcon);
